import { baseURL, googleAnalyticsId } from 'config';
import { mapActions, mapGetters, mapMutations } from "vuex";

import App1 from './App.vue';
import Ripple from 'vue-ripple-directive';
import Router from 'vue-router';
import SocialSharing from 'vue-social-sharing';
import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import VueI18n from 'vue-i18n';
import VueMasonry from 'vue-masonry-css';
import VueStickto from 'vue-stickto';
import VueTimeago from 'vue-timeago';
import _ from "@helpers/_";
import auth from '@firebase/auth';
import axios from 'axios';
import config from 'firebaseConfig';
import database from '@firebase/database';
import firebase from '@firebase/app';
import loggedInUser from './components/loggedInUser.js';
import placeholders from 'placeholders';
import { routes } from './router-config';
import siema from 'vue2-siema';
import store from '@/store.js';
import { sync } from 'vuex-router-sync';

Vue.use(siema);

Vue.directive("focus", {
  inserted: el => el.focus()
});

Vue.directive("auto-direction", {
  inserted: (el, binding) => {
    binding.def.update(el);
  },
  componentUpdated: (el, binding) => {
    binding.def.update(el);
  },
  update: function(el) {
    const str = el.value || el.innerText;
    el.style.direction = _.isUnicode(str) ? 'rtl' : 'ltr';
  }
});

Vue.directive("auto-expand", {
  inserted: (el, binding) => {
    el.setAttribute("baseScrollHeight", el.clientHeight);
    binding.def.update(el);
  },
  update: function(el) {
    const minRows = parseInt(el.getAttribute("data-min-rows"));
    el.rows = minRows;
    const baseScrollHeight = el.getAttribute("baseScrollHeight");
    const rows = Math.floor(
      (el.scrollHeight - baseScrollHeight) / baseScrollHeight
    );
    el.rows = minRows + rows;
  }
});

Vue.use(VueStickto);

Vue.directive('ripple', Ripple);
Vue.use(VueMasonry);

Vue.prototype.$globals = placeholders;

const app = firebase.initializeApp(config);

Object.defineProperty(Vue.prototype, 'firebase', { value: app.firebase_ });
Object.defineProperty(Vue.prototype, 'app', { value: app });

Vue.use(VueTimeago, {
  name: 'timeago',
  locale: 'en-US',
  locales: {
    // 'en-US': require('vue-timeago/locales/en-US.json')
    'en-US': require('./../static/locales/en.json'),
  }
});


axios.interceptors.request.use(async(config) => {
  const loggedInUser = await store.dispatch("loggedInUser");
  if (loggedInUser) {
    config.headers.token = await loggedInUser.getIdToken();
  }

  config.baseURL = baseURL;
  return config;
});

Vue.prototype.$http = axios;

Vue.use(VueI18n);
Vue.use(Router);
Vue.use(SocialSharing);

const router = new Router({
  routes,
  mode: 'history',
  saveScrollPosition: true,
});
sync(store, router);

router.beforeEach(async(to, from, next) => {

  const isDynamicLink = to.query.dynamicLink || to.query.add_to_group;
  if (!to.meta.requiresAuth && !isDynamicLink) return next();
  const isLoggedIn = await store.dispatch('isLoggedIn');

  if (isDynamicLink) {
    const targetPath = to.fullPath.split('?')[0];
    if (isLoggedIn) {
      let add_to_group = to.query.add_to_group;
      const group_name = await store.dispatch('addToGroup', { group_id: add_to_group });
      let message = i18n.t("group_member_joind", { 0: group_name });
      history.replaceState(null, null, targetPath);
      await store.dispatch('setMessage', message);
      return next('/groups');
    } else {
      localStorage.setItem('fullPath', to.fullPath);
      await store.dispatch('showLoginDialog');
      return next(targetPath);
    }
  } else if (isLoggedIn) {
    return next();
  } else {
    store.dispatch('showLoginDialog');
  }

});

router.afterEach(async(to, from) => {
  document.querySelector('html').className = to.name;
  const message = await store.state.message;
  const showLogin = await store.state.showLogin;
  if (showLogin) {
    await store.dispatch('hideLoginDialog');
  } else if (message) {
    await store.dispatch('setMessage', null);
    setTimeout(() => {
      alert(message);
    }, 2000);
  }
});

Vue.use(VueAnalytics, { id: googleAnalyticsId, router });

let locale_default = window.localStorage.getItem('lang');
if (!locale_default || locale_default === 'default') {
  locale_default = (window.navigator.userLanguage || window.navigator.language).split('-')[0];
  // locale_default = 'en-US';
}

const i18n = new VueI18n({
  locale: locale_default,
  fallbackLocale: 'en-US',
  messages: {
    'en-US': require('./../static/locales/en.json'),
    'he-IL': require('./../static/locales/he.json'),
    // 'he': require('./../static/locales/he.json'),
    'es': require('./../static/locales/es.json')
  }
});

Vue.config.productionTip = false;

firebase.auth().onAuthStateChanged(async(user) => {

  new Vue({
    mixins: [loggedInUser],
    i18n,
    router,
    store,
    computed: {
      ...mapGetters(['getLoggedInUser', 'isLoggedIn'])
    },
    async mounted() {
      const self = this;
      let url = new URL(window.location.href);

      if (window.history.length === 1) {
        const currentRoute = window.location.href;
        if ((new URL(currentRoute)).pathname.replace('/', '').trim() !== "") {
          history.replaceState(null, null, '/');
          history.pushState(null, null, currentRoute);
        }
      }

      const token = url.searchParams.get("token");
      if (token) {
        const signin = await firebase.auth().signInWithCustomToken(token);
        this.$router.replace("/");
      }


      if (user) {

        this.watchMyGroups();
        this.watchTotalCount();
        this.watchCurrentUser(user.uid);
        this.getConversations();
        this.watchOnlineStatus();
        this.setLoggedInUserId(user.uid);

        const fullPath = localStorage.getItem('fullPath');
        if (fullPath) {
          localStorage.removeItem('fullPath');
          this.$router.push({ path: fullPath });
        }

      }


      const messaging = await
      import ( /* webpackChunkName: "messaging" */ '@/helpers/messaging');
      messaging.default({ firebase: this.firebase, store: this.$store });

    },
    methods: {
      ...mapMutations(["setLoggedInUserId"]),
      ...mapActions([
        "routeChanged",
        "addToGroup",
        "watchCurrentUser",
        "watchMyGroups",
        "watchTotalCount",
        "getConversations",
        "watchOnlineStatus"
      ]),
    },
    render: createEle => createEle(App1),
  }).$mount('#app');
  // 289
});
